import { createSlice } from "@reduxjs/toolkit";

import { addSnackAsync } from "../../app/coreSlice";

import {
  getZones,
  addZone as addZoneDUMMY,
  updateZone as updateZoneDUMMY,
  removeZone as removeZoneDUMMY,
  getBoxs,
  addBox as addBoxDUMMY,
  updateBox as updateBoxDUMMY,
  removeBox as removeBoxDUMMY,
  getSensors,
  addSensor as addSensorDUMMY,
  updateSensor as updateSensorDUMMY,
  removeSensor as removeSensorDUMMY,
} from "../../api/fakeApi/project";

import { localAPI, anandaAPI } from "../../api/nodeRedApi/axiosApi";

import {
  structureGet,
  addZone as addZoneAPI,
  updateZone as updateZoneAPI,
  removeZone as removeZoneAPI,
  addBox as addBoxAPI,
  updateBox as updateBoxAPI,
  removeBox as removeBoxAPI,
  addSensor as addSensorAPI,
  updateSensor as updateSensorAPI,
  removeSensor as removeSensorAPI,
  getSensorReadings as getSensorReadingsAPI,
} from "../../api/nodeRedApi/project";

import { getSensorReadings as getSensorReadingsDUMMY } from "../../api/fakeApi/sensors";
import { sleep } from "../../common/utils/utils";

export const structureSlice = createSlice({
  name: "structure",
  initialState: {
    loader: null,
    error: null,
    structure: [],
    status: null,
    sensorReadings: [],
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    setStructure: (state, action) => {
      state.structure = action.payload;
    },

    setStatus: (state, action) => {
      state.status = action.payload;
    },

    setSensorReadings: (state, action) => {
      state.sensorReadings = action.payload;
    },
  },
});

export const { setLoader, setError, setStructure, setStatus, setSensorReadings } = structureSlice.actions;

export const getStructure = (project) => async (dispatch) => {
  console.log("GET");
  dispatch(setLoader("LOADING"));
  let zones = [];
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      console.log("LOCAL");

      let struct = await structureGet(project.id === "LOCAL" ? localAPI : anandaAPI);
      console.log("struct", struct);
      zones = struct.data;
      break;

    default:
      zones = [...getZones()];
      console.log("zones: %o", zones);
      zones.forEach((zone) => {
        zone.boxs = getBoxs(zone.id);
        zone.boxs.forEach((box) => {
          box.sensors = getSensors(box.id);
        });
      });
      await sleep(1000);
      break;
  }
  dispatch(setStructure(zones));
  dispatch(setLoader(null));
};

export const addZone =
  (project, { designation, description }) =>
  async (dispatch) => {
    console.log("ADD");
    dispatch(setLoader("ADD_ZONE"));
    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await addZoneAPI(project.id === "LOCAL" ? localAPI : anandaAPI, designation, description);
        dispatch(getStructure(project));
        break;
      default:
        addZoneDUMMY(designation, description);
        await sleep(1000);
        break;
    }
    dispatch(addSnackAsync("success", "ZONE_ADDED"));
    dispatch(setLoader(null));
  };

export const updateZone =
  (project, { id, designation, description }) =>
  async (dispatch) => {
    console.log("UPDATE");
    dispatch(setLoader("UPDATE_ZONE"));
    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await updateZoneAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id, designation, description);
        console.log("--- here");
        dispatch(getStructure(project));
        break;
      default:
        updateZoneDUMMY(id, designation, description);
        await sleep(2000);
        break;
    }
    dispatch(addSnackAsync("success", "ZONE_UPDATED"));
    dispatch(setLoader(null));
  };

export const removeZone = (project, id) => async (dispatch) => {
  console.log("REMOVE id: %o", id);
  dispatch(setLoader("REMOVE_ZONE"));
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      await removeZoneAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id);
      dispatch(getStructure(project));
      break;
    default:
      removeZoneDUMMY(id);
      await sleep(2000);
      break;
  }
  dispatch(addSnackAsync("success", "ZONE_REMOVED"));
  dispatch(setLoader(null));
};

export const addBox =
  (project, { designation, description, zoneId }) =>
  async (dispatch) => {
    console.log("ADD");
    dispatch(setLoader("ADD_BOX"));
    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await addBoxAPI(project.id === "LOCAL" ? localAPI : anandaAPI, designation, description, zoneId);
        dispatch(getStructure(project));
        break;
      default:
        addBoxDUMMY(designation, description, zoneId);
        await sleep(1000);
        break;
    }
    dispatch(setStatus("BOX_ADDED"));
    dispatch(setLoader(null));

    await sleep(10000);
    dispatch(setStatus(null));
  };

export const updateBox =
  (project, { id, designation, description, zoneId }) =>
  async (dispatch) => {
    console.log("UPDATE");
    dispatch(setLoader("UPDATE_BOX"));

    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await updateBoxAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id, designation, description, zoneId);
        dispatch(getStructure(project));
        break;
      default:
        updateBoxDUMMY(id, designation, description, zoneId);
        await sleep(1000);
        break;
    }
    dispatch(setStatus("BOX_UPDATED"));
    dispatch(setLoader(null));

    await sleep(10000);
    dispatch(setStatus(null));
  };

export const removeBox = (project, id) => async (dispatch) => {
  console.log("REMOVE id: %o", id);
  dispatch(setLoader("REMOVE_BOX"));

  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      await removeBoxAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id);
      dispatch(getStructure(project));
      break;
    default:
      removeBoxDUMMY(id);
      await sleep(1000);
      break;
  }
  dispatch(setStatus("BOX_REMOVED"));
  dispatch(setLoader(null));

  await sleep(10000);
  dispatch(setStatus(null));
};

export const addSensor =
  (project, { designation, description, type, model, code, config, boxId }) =>
  async (dispatch) => {
    console.log("ADD");

    dispatch(setLoader("ADD_SENSOR"));

    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await addSensorAPI(
          project.id === "LOCAL" ? localAPI : anandaAPI,
          designation,
          description,
          type,
          model,
          code,
          config,
          boxId
        );
        dispatch(getStructure(project));
        break;
      default:
        addSensorDUMMY(designation, description, type, model, code, config, boxId);
        await sleep(1000);
        break;
    }
    dispatch(setStatus("SENSOR_ADDED"));
    dispatch(setLoader(null));

    await sleep(10000);
    dispatch(setStatus(null));
  };

export const updateSensor =
  (project, { id, designation, description, type, model, code, config, boxId }) =>
  async (dispatch) => {
    console.log("UPDATE: %o", {
      id,
      designation,
      description,
      type,
      model,
      code,
      config,
      boxId,
    });

    dispatch(setLoader("UPDATE_SENSOR"));
    switch (project.id) {
      case "LOCAL":
      case "ANANDA":
        await updateSensorAPI(
          project.id === "LOCAL" ? localAPI : anandaAPI,
          id,
          designation,
          description,
          type,
          model,
          code,
          config,
          boxId
        );
        dispatch(getStructure(project));
        break;
      default:
        updateSensorDUMMY(id, designation, description, type, model, code, config, boxId);
        await sleep(1000);
        break;
    }
    dispatch(setStatus("SENSOR_UPDATED"));
    dispatch(setLoader(null));

    await sleep(10000);
    dispatch(setStatus(null));
  };

export const removeSensor = (project, id) => async (dispatch) => {
  console.log("REMOVE id: %o", id);

  dispatch(setLoader("REMOVE_SENSOR"));
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      await removeSensorAPI(project.id === "LOCAL" ? localAPI : anandaAPI, id);
      dispatch(getStructure(project));
      break;
    default:
      removeSensorDUMMY(id);
      await sleep(1000);
      break;
  }
  dispatch(setStatus("SENSOR_REMOVED"));
  dispatch(setLoader(null));

  await sleep(10000);
  dispatch(setStatus(null));
};

export const getSensorReadings = (project, code, id, type) => async (dispatch) => {
  console.log("GET SENSOR READINGS id: %o", id);
  dispatch(setLoader("GET_SENSOR_READINGS"));
  let readings = [];
  switch (project.id) {
    case "LOCAL":
    case "ANANDA":
      let result = await getSensorReadingsAPI(project.id === "LOCAL" ? localAPI : anandaAPI, code);
      readings = result.data;
      console.log("readings: %o", readings);
      break;
    default:
      readings = getSensorReadingsDUMMY(id, type);
      await sleep(1000);
      break;
  }
  dispatch(setSensorReadings(readings));
  dispatch(setLoader(null));
};

export const selectLoader = (state) => state.structure.loader;
export const selectError = (state) => state.structure.error;
export const selectStructure = (state) => state.structure.structure;
export const selectStatus = (state) => state.structure.status;
export const selectSensorReadings = (state) => state.structure.sensorReadings;
export const selectSelectedProject = (state) => state.authentication.selectedProject;

export default structureSlice.reducer;
